$(".bike-brand-model-list").click(function(){
	if( $(this).hasClass('bike-brand-model-list-selected') ){

		//already selected - do nowt
	}else{

		$('.bike-brand-model-list-selected').removeClass('bike-brand-model-list-selected');
		$(this).addClass('bike-brand-model-list-selected');

		//fix pic

		$('.bike_brand-model-image-selected').removeClass('bike_brand-model-image-selected');

		var dataTarget = $(this).attr('data-model');

		$('.bike_brand-model-image').each(function(){
			if ( $(this).attr('data-model') == dataTarget ){
				$(this).addClass('bike_brand-model-image-selected');
			}
		})
	}
})

